import { ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, effect, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent, TitleComponent, NavigationComponent } from './core/components';
import { NavigationService } from './core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, TitleComponent, NavigationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit, OnDestroy {

  //#region Application Properties
  title = 'Hakikat';

  headerContainer = viewChild.required<ElementRef>('header');
  //#endregion

  //#region Materials
  #resizeObserver?: ResizeObserver;
  //#endregion

  //#region Services
  readonly navigationService = inject(NavigationService);
  //#endregion

  //#region Constructor
  constructor(viewportScroller: ViewportScroller) {
    effect(() => {
      viewportScroller.setOffset([0, this.navigationService.height()]);
    });
  }
  //#endregion

  //#region Lifecycle Hooks
  ngAfterViewInit() {
    this.#resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.navigationService.height.set(entry.contentRect.height);
      }
    });

    this.#resizeObserver.observe(this.headerContainer().nativeElement);
  }

  ngOnDestroy() {
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
    }
  }
  //#endregion
}
